import React, {useEffect, useState, useRef} from "react";
import {
    Building2,
    Landmark,
    Pencil,
    X,
    Save,
    Plus,
    Trash,
} from "lucide-react";
import Cookies from "js-cookie";
import axios from "axios";
import httpClient from "../../../../../api/httpClient";
import {toast} from "react-toastify";
import {usePrivilege} from "../../../../../guard/usePrivilege";
import HeaderActions from "../../../../../components/ModuleCommon/StickyHeader/HeaderActions";
import ConfirmModal from "../../../SystemUsers/ConfirmModal";
import {deleteOffice, addChildOrganization, checkOfficeCode} from "../../api";
import {DisplayDetail} from "../../../../../components/ACS-Dashboard/ACS-Blocks/DisplayDetail";
import GeoTypeaheadField from "../../../../../components/ACS-Dashboard/ACS-Blocks/GeoTypeaheadField";
import {
    sectionCardClass,
    sectionHeaderBarClass,
    sectionFieldGridClass,
    sectionContentClass,
    ErrorHint,
} from "../../../../../components/ACS-Dashboard/ACS-Blocks/sectionStyles";
import {searchCountries, searchStatesByCountry, searchCitiesByCountryState, saveNewCity} from "../../api";
import { parseCalendarApiResponseToDockSettings } from "../../../Appointments/TabContent/utils/dockSettingsParser";
import DockDoorSettings from "../../../Appointments/TabContent/Calendar-Main/DockDoorSettings";
import EditOfficeCalendarModal from "./EditOfficeCalendarModal";

import { isOrgType } from "../../../../../utils/orgType";

const BLANK_NEW_OFFICE = {
    name: "",
    phone: "",
    email: "",
    officeCode: "",
    department: "",
    teamSize: "",
    previousSystem: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    countryName: "",
    state: "",
    stateName: "",
    city: "",
    zipCode: "",
};

const PHONE_REGEX = /^\+?[0-9]{10,15}$/;

const COMMON_TIMEZONES = [
    "US/Alaska",
    "US/Aleutian",
    "US/Arizona",
    "US/Central",
    "US/East-Indiana",
    "US/Eastern",
    "US/Hawaii",
    "US/Indiana-Starke",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific",
    "US/Samoa",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/ComodRivadavia",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Atka",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Buenos_Aires",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Catamarca",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Ciudad_Juarez",
    "America/Coral_Harbour",
    "America/Cordoba",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Ensenada",
    "America/Fort_Nelson",
    "America/Fort_Wayne",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indianapolis",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Jujuy",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Knox_IN",
    "America/Kralendijk",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Louisville",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Mendoza",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montreal",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Nuuk",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Port_of_Spain",
    "America/Porto_Acre",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Rosario",
    "America/Santa_Isabel",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Shiprock",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Virgin",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife"
];

const ViewPreferredPartnerDetails = ({orgData: initialOrgData, onClose, isNew = false, parentOfficeCode, onSuccess}) => {
    const [orgData, setOrgData] = useState(isNew ? {...BLANK_NEW_OFFICE} : initialOrgData);
    const [formData, setFormData] = useState(isNew ? {...BLANK_NEW_OFFICE} : (initialOrgData || {}));
    const [isEditing, setIsEditing] = useState(isNew);
    const [loading, setLoading] = useState(!isNew);
    const [savingNewOffice, setSavingNewOffice] = useState(false);
    const [newOfficeErrors, setNewOfficeErrors] = useState({});
    const [reloading, setReloading] = useState(false);
    const [contactPersons, setContactPersons] = useState([]);
    const [loadingContacts, setLoadingContacts] = useState(false);
    const [editingContactIndex, setEditingContactIndex] = useState(null);
    const [editedContact, setEditedContact] = useState(null);
    const [timezoneSearch, setTimezoneSearch] = useState("");
    const [confirmDeleteOffice, setConfirmDeleteOffice] = useState(false);
    const [deletingOffice, setDeletingOffice] = useState(false);
    const scrollRef = useRef(null);

    const token = Cookies.get("authToken");
    const userOfficeCode = Cookies.get("officeCodes");
    const [chargeTolerances, setChargeTolerances] = useState([]);
const [loadingTolerances, setLoadingTolerances] = useState(false);
const [originalChargeTolerances, setOriginalChargeTolerances] = useState([]);
const [savingTolerances, setSavingTolerances] = useState(false);
const [isEditingTolerances, setIsEditingTolerances] = useState(false);
const [editingToleranceRows, setEditingToleranceRows] = useState(new Set());
const [shippers, setShippers] = useState([]);
const [loadingShippers, setLoadingShippers] = useState(false);

const [userProfile, setUserProfile] = useState(null);
const [auditLogs, setAuditLogs] = useState([]);
const [loadingAuditLogs, setLoadingAuditLogs] = useState(false);
const [showAuditTrail, setShowAuditTrail] = useState(false);
const [isEditingLocation, setIsEditingLocation] = useState(false);
const [locationFormData, setLocationFormData] = useState({});

// LGX-1163: office-level calendar (hours/holidays/blackouts), independent of any warehouse
// Location's own calendar.
const [officeCalendarSettings, setOfficeCalendarSettings] = useState(null);
const [officeCalendarLoading, setOfficeCalendarLoading] = useState(false);
const [officeCalendarError, setOfficeCalendarError] = useState(null);
const [creatingOfficeCalendar, setCreatingOfficeCalendar] = useState(false);
const [openEditOfficeCalendarModal, setOpenEditOfficeCalendarModal] = useState(false);
const loggedInEmail = JSON.parse(Cookies.get("userData") || "{}").email;




    const {hasPrivilege} = usePrivilege();
    // organizationProfile:EDIT/editContacts/assignContacts were all granted broadly (Admin Role,
    // SHIPPER VIEW, Carrier View); editing organization/location/contact info here is admin-only
    // (LGX-1006 follow-up), consolidated under one privilege.
    const canEditOrganization = hasPrivilege("manageTeam:ADMIN") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    const canEditContacts = hasPrivilege("manageTeam:ADMIN") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    const canRemoveContacts = hasPrivilege("manageTeam:ADMIN") &&
        userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);


  
  const userOfficeCodes = (userOfficeCode || "")
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
  


//     const canViewTolerances =
//   hasPrivilege("organizationProfile:viewTolerances") &&
//   userOfficeCodes.includes(orgData.officeCode);

//   const canEditTolerances =
//   canViewTolerances && hasPrivilege("organizationProfile:editTolerances");

// // only show tolerances for the user’s office codes
// const visibleChargeTolerances = chargeTolerances.filter((tol) =>
//   userOfficeCodes.includes((tol?.shipperCode || "").trim())
// );

// // also restrict shipper dropdown to user office codes
// const visibleShippers = shippers.filter((s) =>
//   userOfficeCodes.includes((s?.officeCode || "").trim())
// );

const userShipperOfficeCodes = (userProfile?.organizations ?? [])
  .filter((org) => isOrgType(org, "Shipper"))
  .map((org) => (org.officeCode || "").trim());

const canViewTolerances = userShipperOfficeCodes.includes((orgData?.officeCode || "").trim());

const canEditTolerances = canViewTolerances && hasPrivilege("manageTeam:ADMIN");

// Only meaningful when this org is the caller's own office hierarchy (reached via Office
// Management) -- an unrelated Preferred Partner's org fails the same office-scoping check the
// backend enforces, so the button simply 403s there rather than needing a separate context flag.
const canRemoveOffice = canEditOrganization;

const handleConfirmDeleteOffice = async () => {
    setDeletingOffice(true);
    try {
        await deleteOffice(orgData.org_id ?? orgData.id);
        toast.success(`${orgData.name} removed.`);
        setConfirmDeleteOffice(false);
        if (onClose) onClose();
    } catch (err) {
        toast.error(err?.response?.data?.content || `Failed to remove ${orgData.name}.`);
        setConfirmDeleteOffice(false);
    } finally {
        setDeletingOffice(false);
    }
};

const visibleChargeTolerances = chargeTolerances.filter((tol) =>
  userShipperOfficeCodes.includes((tol?.shipperCode || "").trim())
);

const visibleShippers = shippers.filter((s) =>
  userShipperOfficeCodes.includes((s?.officeCode || "").trim())
);

const [autoApprovalConfig, setAutoApprovalConfig] = useState({});   
const [loadingAutoApproval, setLoadingAutoApproval] = useState(false);
const [savingAutoApproval, setSavingAutoApproval] = useState(null);  

    // Helper function to convert 24-hour time to 12-hour format with AM/PM
    const formatTo12Hour = (time24) => {
        if (!time24) return "—";
        const [hours, minutes] = time24.split(":");
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };
    const fetchChargeTolerances = async () => {
        try {
            setLoadingTolerances(true);
            const res = await httpClient.get(
                `/api/invoice-charges/tolerance`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Office-Code": orgData.officeCode,
                    },
                }
            );
            const data = Array.isArray(res.data) ? res.data : [];
            setChargeTolerances(data);
            setOriginalChargeTolerances(data);
                    } catch (err) {
            console.error("❌ Failed to fetch charge tolerances:", err);
            toast.error("Failed to fetch charge tolerances.");
        } finally {
            setLoadingTolerances(false);
        }
    };

    const fetchShippers = async () => {
        try {
          setLoadingShippers(true);
          const res = await httpClient.get(
            `/api/organizations/get-shippers`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
      
          const data = Array.isArray(res.data) ? res.data : [];
          setShippers(data);
                  } catch (err) {
          console.error("❌ Failed to fetch shippers:", err);
          toast.error("Failed to fetch shippers.");
        } finally {
          setLoadingShippers(false);
        }
      };
      
      const fetchAutoApprovalConfig = async (shipperCodes) => {
        try {
          setLoadingAutoApproval(true);
          const results = {};
          await Promise.all(
            shipperCodes.map(async (code) => {
              try {
                const res = await httpClient.get(
                  `/api/auto-approval-config`,
                  {
                    params: { shipper: code },
                    headers: { Authorization: `Bearer ${token}` },
                    "Office-Code": code, 
                  }
                );
                results[code] = res.data?.autoApprove ?? false;
              } catch {
                results[code] = false;
              }
            })
          );
          setAutoApprovalConfig(results);
        } catch (err) {
          console.error("❌ Failed to fetch auto-approval config:", err);
          toast.error("Failed to fetch auto-approval settings.");
        } finally {
          setLoadingAutoApproval(false);
        }
      };
      
      const handleToggleAutoApproval = async (officeCode) => {
        const current = autoApprovalConfig[officeCode] ?? false;
        const next = !current;
        setSavingAutoApproval(officeCode);
        try {
          await httpClient.put(
            `/api/auto-approval-config`,
            { autoApprove: next },
            {
              params: { shipper: officeCode },
              headers: { Authorization: `Bearer ${token}` },
              "Office-Code": officeCode
            }
          );
          setAutoApprovalConfig((prev) => ({ ...prev, [officeCode]: next }));
          toast.success(`Auto-approval ${next ? "enabled" : "disabled"} for ${officeCode}.`);
          if (showAuditTrail) await fetchAuditLogs();
        } catch (err) {
          console.error("❌ Failed to update auto-approval:", err);
          toast.error("Failed to update auto-approval setting.");
        } finally {
          setSavingAutoApproval(null);
        }
      };
 
const handleToleranceChange = (index, field, value) => {
  setChargeTolerances((prev) => {
    const current = [...prev];
    const existing = current[index];

    let row = { ...existing, [field]: value };

    // normalize
    row.shipperCode = (row.shipperCode || "").trim();
    row.chargeCode = (row.chargeCode || "").trim().toUpperCase();

    /* ----------------------------
       RESET DEPENDENT FIELDS
    -----------------------------*/
    if (field === "shipperCode") {
      row.chargeCode = "";
      row.toleranceBasis = "";
      row.toleranceValue = "";
    }

    if (field === "chargeCode") {
      row.toleranceBasis = "";
      row.toleranceValue = "";
    }

    if (field === "toleranceBasis") {
      row.toleranceValue = "";
    }

    const { shipperCode, chargeCode, toleranceBasis } = row;

    /* ----------------------------
       DUPLICATE SHIPPER + CHARGE
    -----------------------------*/
    if (shipperCode && chargeCode) {
      const hasDuplicate = current.some((tol, i) => {
        if (i === index) return false;

        return (
          (tol.shipperCode || "").trim() === shipperCode &&
          (tol.chargeCode || "").trim().toUpperCase() === chargeCode
        );
      });

      if (hasDuplicate) {
        toast.error(
          "Only one tolerance is allowed per office code and charge code."
        );
        return prev; // ⛔ reject change
      }
    }

    /* ----------------------------
       FLAT vs PERCENT CONFLICT
    -----------------------------*/
    if (shipperCode && chargeCode && toleranceBasis) {
      const hasConflict = current.some((tol, i) => {
        if (i === index) return false;

        return (
          (tol.shipperCode || "").trim() === shipperCode &&
          (tol.chargeCode || "").trim().toUpperCase() === chargeCode &&
          tol.toleranceBasis &&
          tol.toleranceBasis !== toleranceBasis
        );
      });

      if (hasConflict) {
        toast.error(
          "Cannot mix FLAT and PERCENT for the same office code & charge."
        );
        return prev; // ⛔ reject change
      }
    }

    current[index] = row;
    return current;
  });
};
      
      
      
          
      const handleAddToleranceRow = () => {
        const newIndex = chargeTolerances.length;
      
        const defaultOffice = userShipperOfficeCodes?.[0] || ""; // first shipper office code user has
      
        setChargeTolerances((prev) => [
          ...prev,
          {
            shipperCode: defaultOffice,
            chargeCode: "",
            toleranceBasis: "",
            toleranceValue: "",
          },
        ]);
      
        setEditingToleranceRows((prev) => {
          const next = new Set(prev);
          next.add(newIndex);
          return next;
        });
      
        setIsEditingTolerances(true);
      };
      
        
      const handleSaveTolerances = async () => {
        if (!chargeTolerances || chargeTolerances.length === 0) {
          toast.info("No charge tolerances to save.");
          return;
        }

     
      
        const normalized = chargeTolerances
          .map((tol) => ({
            ...tol,
            shipperCode: (tol.shipperCode || "").trim(),
            chargeCode: (tol.chargeCode || "").trim().toUpperCase(),
          }))
          .filter((tol) => !!tol.shipperCode);
      
        const seen = new Set();

for (const tol of normalized) {
  const key = `${tol.shipperCode}||${tol.chargeCode}`;
  if (seen.has(key)) {
    toast.error(
      `Only one tolerance is allowed per Office Code & Charge Code (${tol.chargeCode}).`
    );
    return;
  }
  seen.add(key);
}
      
      
        // Existing basis validation (you can keep or remove; it's redundant but harmless now)
        const basisCountByKey = {};
      
        for (const tol of normalized) {
          const { shipperCode, chargeCode, toleranceBasis } = tol;
          if (!shipperCode || !chargeCode) continue;
      
          const key = `${shipperCode}||${chargeCode}`;
          if (!basisCountByKey[key]) basisCountByKey[key] = 0;
          if (toleranceBasis) basisCountByKey[key]++;
        }
      
        const invalidCharges = Object.entries(basisCountByKey)
          .filter(([, count]) => count > 1)
          .map(([key]) => key.split("||")[1]);
      
        if (invalidCharges.length) {
          const uniqueCharges = [...new Set(invalidCharges)];
          toast.error(
            `Only one tolerance basis is allowed per office code & charge code. Conflicting charges: ${uniqueCharges.join(", ")}`
          );
          return;
        }
      
        const groupedByShipper = normalized.reduce((acc, tol) => {
          const code = tol.shipperCode;
          if (!acc[code]) acc[code] = [];
          acc[code].push(tol);
          return acc;
        }, {});
      
        try {
          setSavingTolerances(true);
      
          const baseUrl = `/api/invoice-charges/tolerance`;
      
          await Promise.all(
            Object.entries(groupedByShipper).map(([shipperCode, list]) =>
              httpClient.put(baseUrl, list, {
                params: { shipperCode },
                headers: { Authorization: `Bearer ${token}` },
              })
            )
          );
      
          toast.success("Charge tolerances updated successfully!");
          await fetchChargeTolerances();
          if (showAuditTrail) await fetchAuditLogs();
          setEditingToleranceRows(new Set());
          setIsEditingTolerances(false);
        } catch (err) {
          console.error("❌ Failed to update charge tolerances:", err);
          toast.error("Failed to update charge tolerances.");
        } finally {
          setSavingTolerances(false);
        }
      };
      
              
      const fetchUserProfile = async () => {
        if (!loggedInEmail) return;
        try {
            const res = await httpClient.get(
                `/auth/user/viewprofile?userEmail=${encodeURIComponent(loggedInEmail)}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUserProfile(res.data);
        } catch (err) {
            console.error("❌ Failed to fetch user profile:", err);
            toast.error("Failed to load your profile. Invoice settings may not display correctly.");
        }
    };  
    
    

    const fetchContactPersons = async (officeCode) => {
        if (!officeCode) return;
        try {
            setLoadingContacts(true);
            const res = await httpClient.get(
                `/auth/user/contact-persons/${officeCode}`,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            const raw = Array.isArray(res.data) ? res.data : [res.data];
            const cleaned = raw.filter(c => c && typeof c === "object"); // prevent null entries
            setContactPersons(cleaned);
                    } catch (err) {
            console.error("❌ Failed to fetch contact persons:", err);
            toast.error("Failed to fetch contact persons.");
        } finally {
            setLoadingContacts(false);
        }
    };

    // 🔁 Fetch organization details
    const refreshOrgDetails = async () => {
        const officeCode = initialOrgData?.officeCode;
        if (!officeCode) return;
        try {
            setReloading(true);
            const res = await httpClient.get(
                `/api/organizations/by-office-code/${encodeURIComponent(officeCode)}`,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            setOrgData(res.data);
            setFormData(res.data);
            
            if (res.data?.officeCode) {
                await fetchContactPersons(res.data.officeCode);
            }
            await fetchChargeTolerances();
            await fetchUserProfile();
            await fetchShippers();
           
let profileData = null;
try {
  const profileRes = await httpClient.get(
    `/auth/user/viewprofile?userEmail=${encodeURIComponent(loggedInEmail)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  profileData = profileRes.data;
  setUserProfile(profileData);
} catch (err) {
  console.error("❌ Failed to fetch user profile:", err);
}

// Scoped to the office actually being viewed -- previously defaulted to the VIEWER's entire
// shipper office list, which showed every sibling office's auto-approval toggle on this one
// office's details page (LGX-1006 follow-up cross-office leak).
await fetchAutoApprovalConfig(res.data?.officeCode ? [res.data.officeCode] : []);

        } catch (err) {
            console.error("❌ Failed to fetch org details:", err);
            toast.error("Failed to refresh organization details.");
        } finally {
            setReloading(false);
            setLoading(false);
        }
    };

    const resolveOfficeOrgId = (org) => org?.org_id ?? org?.id ?? null;

    // Organization JSON exposes calendar_id only. The calendar object itself is omitted,
    // so org.calendar.calendarRefId is never present on a freshly loaded office.
    const officeHasCalendar = (org) =>
        Boolean(org?.calendar?.calendarRefId || org?.calendar_id || org?.calendarId);

    const loadOfficeCalendar = async (orgId) => {
        if (!orgId) {
            setOfficeCalendarSettings(null);
            return;
        }
        setOfficeCalendarLoading(true);
        setOfficeCalendarError(null);
        try {
            const res = await httpClient.get(`/api/organizations/${orgId}/calendar`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const settings = parseCalendarApiResponseToDockSettings(res.data || {});
            setOfficeCalendarSettings(settings);
            if (settings?.calendarRefId || settings?.calendarId) {
                setOrgData((prev) =>
                    prev
                        ? {
                              ...prev,
                              calendar_id: settings.calendarId ?? prev.calendar_id,
                              calendar: {
                                  ...(prev.calendar || {}),
                                  calendarId: settings.calendarId ?? prev.calendar?.calendarId,
                                  calendarRefId:
                                      settings.calendarRefId || prev.calendar?.calendarRefId,
                              },
                          }
                        : prev
                );
            }
        } catch (err) {
            console.error("❌ Failed to fetch office calendar settings:", err);
            setOfficeCalendarError("Unable to load calendar settings.");
            setOfficeCalendarSettings(null);
        } finally {
            setOfficeCalendarLoading(false);
        }
    };

    useEffect(() => {
        const orgId = resolveOfficeOrgId(orgData);
        if (!orgId || !officeHasCalendar(orgData)) {
            return;
        }
        loadOfficeCalendar(orgId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgData?.org_id, orgData?.id, orgData?.calendar_id, orgData?.calendarId]);

    // First use: create the office calendar (default 9am-5pm Mon-Sun), then load it from
    // GET /api/organizations/{id}/calendar. A plain org refresh cannot show the hours,
    // because that payload does not include the calendar.
    const handleCreateOfficeCalendar = async () => {
        const orgId = resolveOfficeOrgId(orgData) ?? resolveOfficeOrgId(initialOrgData);
        if (!orgId) {
            toast.error("This office has no id, so office hours cannot be set up.");
            return;
        }
        setCreatingOfficeCalendar(true);
        try {
            await httpClient.post(
                `/api/organizations/${orgId}/calendar`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );
            await loadOfficeCalendar(orgId);
            toast.success("Office hours set up.");
        } catch (err) {
            console.error("❌ Failed to create office calendar:", err);
            toast.error(
                err?.response?.status === 403
                    ? "You do not have permission to set up office hours."
                    : "Failed to set up office hours."
            );
        } finally {
            setCreatingOfficeCalendar(false);
        }
    };

    const handleOfficeCalendarSaved = async () => {
        const orgId = resolveOfficeOrgId(orgData) ?? resolveOfficeOrgId(initialOrgData);
        await loadOfficeCalendar(orgId);
    };

    // 📋 Fetch audit logs for this organization
    const fetchAuditLogs = async () => {
        try {
            setLoadingAuditLogs(true);
            const res = await httpClient.get(
                `/api/organizations/${orgData.org_id}/audit-log`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setAuditLogs(res.data || []);
        } catch (err) {
            console.error("Failed to fetch audit logs:", err);
        } finally {
            setLoadingAuditLogs(false);
        }
    };

    // 📍 Start editing location
    const handleEditLocation = () => {
        setLocationFormData({
            addressLine1: orgData.location?.addressLine1 || "",
            addressLine2: orgData.location?.addressLine2 || "",
            city: orgData.location?.city || "",
            state: orgData.location?.state || "",
            zipCode: orgData.location?.zipCode || "",
            country: orgData.location?.country || "",
        });
        setIsEditingLocation(true);
    };

    // 💾 Save location updates
    const handleSaveLocation = async () => {
        try {
            setLoading(true);
            await httpClient.put(
                `/api/organizations/${orgData.org_id}/location`,
                locationFormData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success("Location updated successfully!");
            setIsEditingLocation(false);
            await refreshOrgDetails();
            if (showAuditTrail) await fetchAuditLogs();
        } catch (err) {
            console.error("Failed to update location:", err);
            toast.error("Failed to update location.");
        } finally {
            setLoading(false);
        }
    };
    // 💾 Save organization updates
    const handleSave = async () => {
        try {
            setLoading(true);
            await httpClient.put(
                `/api/organizations/${orgData.org_id}`,
                formData,
                {
                    headers: {Authorization: `Bearer ${token}`},
                    params: { userEmail: loggedInEmail }
                }
            );
                        toast.success("Organization updated successfully!");
            setIsEditing(false);
            await refreshOrgDetails();
            if (showAuditTrail) await fetchAuditLogs();
        } catch (err) {
            console.error("❌ Failed to update organization:", err);
            toast.error("Failed to update organization.");
        } finally {
            setLoading(false);
        }
    };

    // ✏️ Start editing contact
    const handleEditContact = async (index) => {
        const original = contactPersons[index];
        if (!original) {
            toast.error("Invalid contact record.");
            return;
        }
        setEditingContactIndex(index);
        const contactData = {...original};
        try {
            // Third-party public API, not our backend — use plain axios so our
            // internal auth token isn't sent to an external host.
            const timezoneRes = await axios.get('http://worldtimeapi.org/api/ip');
            const timezone = timezoneRes.data?.timezone || "US/Eastern";
            contactData.startWorkingHoursZone = contactData.startWorkingHoursZone || timezone;
            contactData.endWorkingHoursZone = contactData.endWorkingHoursZone || timezone;
        } catch {
            contactData.startWorkingHoursZone = contactData.startWorkingHoursZone || "US/Eastern";
            contactData.endWorkingHoursZone = contactData.endWorkingHoursZone || "US/Eastern";
        }
        setEditedContact(contactData);
        setTimezoneSearch("");
    };

    // 💾 Save contact updates
    const handleSaveContact = async () => {
        if (!editedContact) return;
        try {
            setLoadingContacts(true);
            const email = encodeURIComponent(editedContact.email);
            await httpClient.put(
                `/auth/user/contact-persons/${email}`,
                editedContact,
                {headers: {Authorization: `Bearer ${token}`}}
            );
            toast.success("Contact person updated successfully!");
            setEditingContactIndex(null);
            setEditedContact(null);
            await fetchContactPersons(orgData.officeCode);
            if (showAuditTrail) await fetchAuditLogs();
        } catch (err) {
            console.error("❌ Failed to update contact person:", err);
            toast.error("Failed to update contact person.");
        } finally {
            setLoadingContacts(false);
        }
    };

    // ❌ Cancel contact editing
    const handleCancelContactEdit = () => {
        setEditingContactIndex(null);
        setEditedContact(null);
    };

    // 🗑️ Remove contact person
    const handleRemoveContactPerson = async (contact) => {
        try {
            setLoadingContacts(true);
            const email = encodeURIComponent(contact.email);
            await httpClient.post(
                `/auth/user/contact-persons/${email}/toggle?showOnOrgProfile=false`,
                {},
                {headers: {Authorization: `Bearer ${token}`}}
            );
            toast.success("Contact person removed successfully!");
            await fetchContactPersons(orgData.officeCode);
            if (showAuditTrail) await fetchAuditLogs();
        } catch (err) {
            console.error("❌ Failed to remove contact person:", err);
            toast.error("Failed to remove contact person.");
        } finally {
            setLoadingContacts(false);
        }
    };

    const formatPhoneNumberForDisplay = (rawValue) => {
        if (!rawValue) return "";
        const digitsOnly = rawValue.replace(/\D/g, "");
        if (!digitsOnly) return "";

        if (digitsOnly.length <= 10) {
            const area = digitsOnly.slice(0, 3);
            const mid = digitsOnly.slice(3, 6);
            const end = digitsOnly.slice(6);
            if (digitsOnly.length <= 6) return `(${area}) ${mid}`.trim();
            return `(${area}) ${mid}${end ? `-${end}` : ""}`.trim();
        }

        const country = digitsOnly.slice(0, digitsOnly.length - 10);
        const area = digitsOnly.slice(-10, -7);
        const mid = digitsOnly.slice(-7, -4);
        const end = digitsOnly.slice(-4);
        return `+${country} (${area}) ${mid}-${end}`;
    };

    const handlePhoneBlur = () => {
        if (!editedContact) return;
        const formatted = formatPhoneNumberForDisplay(editedContact.phoneNumber);
        setEditedContact({...editedContact, phoneNumber: formatted});
    };
    const editingChargeTolerances = chargeTolerances.filter((_, index) =>
    editingToleranceRows.has(index)
  );

    useEffect(() => {
        if (isNew) return;
        refreshOrgDetails();
    }, [initialOrgData?.officeCode, isNew]);

    if (loading)
        return (
            <div className="flex items-center justify-center h-full text-gray-500 dark:text-acs-dark-subtext">
                Loading organization details...
            </div>
        );

    if (!orgData)
        return (
            <div className="p-6 text-gray-500 dark:text-acs-dark-subtext">
                No organization data available.
            </div>
        );

    // --- New-office field handling (create mode) ---
    const handleNewOfficeChange = (field, value) => {
        setFormData((prev) => ({...prev, [field]: value}));
        setOrgData((prev) => ({...prev, [field]: value}));
        if (newOfficeErrors[field]) {
            setNewOfficeErrors((prev) => {
                const next = {...prev};
                delete next[field];
                return next;
            });
        }
    };

    const handleSaveNewOffice = async () => {
        // State and Zip Code are deliberately NOT required -- not every country uses them
        // (UK has no US-style "state"; Singapore is a city-state with no separate province;
        // Guatemala and others don't consistently use postal codes).
        const required = ["name", "phone", "email", "officeCode", "addressLine1", "city", "country"];
        const errors = {};
        required.forEach((field) => {
            if (!String(formData[field] ?? "").trim()) errors[field] = "Required";
        });
        // Users naturally type phone numbers with spaces/parens/dashes (e.g. "+1 209 400 1234"),
        // but PHONE_REGEX (matching the backend's own @Pattern) only accepts a bare digit string --
        // strip that formatting before validating/submitting rather than rejecting valid numbers.
        const cleanedPhone = String(formData.phone ?? "").replace(/[\s().-]/g, "");
        if (cleanedPhone && !PHONE_REGEX.test(cleanedPhone)) {
            errors.phone = "Invalid phone number (10-15 digits, optional +).";
        }
        if (Object.keys(errors).length > 0) {
            setNewOfficeErrors(errors);
            return;
        }

        setSavingNewOffice(true);
        try {
            const isValidCode = await checkOfficeCode(formData.officeCode);
            if (!isValidCode) {
                setNewOfficeErrors({officeCode: "Office code already in use."});
                setSavingNewOffice(false);
                return;
            }
        } catch {
            setNewOfficeErrors({officeCode: "Office code already in use."});
            setSavingNewOffice(false);
            return;
        }

        try {
            await addChildOrganization(parentOfficeCode, {...formData, phone: cleanedPhone});
            toast.success(`${formData.name} added.`);
            onSuccess?.(formData.officeCode);
            onClose?.();
        } catch (err) {
            toast.error(err?.response?.data?.content || "Failed to add office.");
        } finally {
            setSavingNewOffice(false);
        }
    };

    // const canEditContacts = userOfficeCode?.split(',').some(code => code.trim() === orgData.officeCode);
    return (
        <div
            ref={scrollRef}
            className="w-full h-full flex flex-col transition-opacity duration-500 bg-gray-50 dark:bg-acs-dark-bg"
        >
            {/* === Top Header === */}
            <div
                className="sticky top-0 z-10 bg-white dark:bg-acs-dark-surface shadow-md p-fluid-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-fluid-3">
                <div className="flex items-center gap-fluid-3">
                    <div
                        className="w-20 h-20 rounded-full bg-acs-accent/20 dark:bg-acs-accent/30 flex items-center justify-center shadow-inner">
                        <Building2 className="w-10 h-10 text-blue-600 dark:text-acs-accent"/>
                    </div>
                    <div>
                        <h2 className="text-fluid-xl font-semibold text-gray-900 dark:text-acs-dark-text">
                            {isNew ? "Add Office" : (orgData.name || "Untitled Organization")}
                        </h2>
                        <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">
                            {isNew ? "Enter details to create a new office" : `Office Code: ${orgData.officeCode || "—"}`}
                        </p>
                    </div>
                </div>
                {!isNew && (
                <HeaderActions
                    slideFrom="right"
                    buttons={[
                        {
                            label: "Audit Trail",
                            onClick: () => {
                                setShowAuditTrail(true);
                                fetchAuditLogs();
                            },
                        },
                        ...(canRemoveOffice
                            ? [{
                                label: "Remove Office",
                                color: "red",
                                onClick: () => setConfirmDeleteOffice(true),
                            }]
                            : []),
                    ]}
                />
                )}
            </div>

            {!isNew && confirmDeleteOffice && (
                <ConfirmModal
                    title="Remove Office?"
                    message={`This will permanently remove "${orgData.name}", including any offices nested under it. This cannot be undone.`}
                    confirmLabel={deletingOffice ? "Removing..." : "Remove"}
                    danger
                    onConfirm={handleConfirmDeleteOffice}
                    onCancel={() => !deletingOffice && setConfirmDeleteOffice(false)}
                />
            )}

            {/* === Main Content === */}
            <div className="flex-1 overflow-y-auto bg-white dark:bg-acs-dark-bg w-full p-fluid-3">
                    <div className="space-y-fluid-3 mb-fluid-3">
                        {/* === Organization Info === */}
                        <div className={sectionCardClass}>
                            <div className={`${sectionHeaderBarClass} flex items-center justify-between`}>
                                <span>Office Information</span>
                                {isNew ? (
                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={handleSaveNewOffice}
                                            disabled={savingNewOffice}
                                            className="px-3 py-1 text-xs rounded-md bg-white/10 border border-white/30 text-white hover:bg-white/20 disabled:opacity-60"
                                        >
                                            {savingNewOffice ? "Adding..." : "Add Office"}
                                        </button>
                                        <button
                                            onClick={() => onClose?.()}
                                            disabled={savingNewOffice}
                                            className="px-3 py-1 text-xs rounded-md border border-white/30 text-white hover:bg-white/10"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                ) : (
                                <button
                                    onClick={() => {
                                        if (!canEditOrganization) return;
                                        setIsEditing((prev) => !prev);
                                    }}
                                    className={`p-1.5 rounded-full transition ${canEditOrganization ? 'hover:bg-white/10' : 'opacity-50 cursor-not-allowed'}`}
                                    title={
                                        canEditOrganization
                                            ? (isEditing ? "Cancel Editing" : "Edit Organization")
                                            : "You do not have permission to edit"
                                    }
                                    disabled={!canEditOrganization}
                                >
                                    {canEditOrganization && (
                                        isEditing ? (
                                            <X className="w-4 h-4 text-white"/>
                                        ) : (
                                            <Pencil className="w-4 h-4 text-white"/>
                                        )
                                    )}
                                </button>
                                )}
                            </div>

                            <div className={sectionFieldGridClass}>
                                {[
                                    {key: "name", label: "Name", required: isNew},
                                    ...(isNew ? [
                                        {key: "officeCode", label: "Office Code", required: true},
                                        {key: "addressLine1", label: "Address Line 1", required: true},
                                        {key: "addressLine2", label: "Address Line 2"},
                                        {key: "country", label: "Country", required: true, typeahead: true},
                                        {key: "state", label: "State", typeahead: true},
                                        {key: "city", label: "City", required: true, typeahead: true},
                                        {key: "zipCode", label: "Zip Code"},
                                    ] : []),
                                    {key: "phone", label: "Phone", required: isNew, inputType: "tel"},
                                    {key: "email", label: "Email", required: isNew, inputType: "email"},
                                    {key: "department", label: "Department"},
                                    {key: "teamSize", label: "Team Size"},
                                    {key: "previousSystem", label: "Previous System"},
                                ].map(({key, label, required, inputType, typeahead}) => {
                                    if (typeahead) {
                                        if (key === "country") {
                                            return (
                                                <div key={key}>
                                                    <GeoTypeaheadField
                                                        label={label}
                                                        required={required}
                                                        error={newOfficeErrors.country}
                                                        nameValue={formData.countryName}
                                                        searchFn={(q) => searchCountries(q)}
                                                        codeKeys={["code", "countryCode", "isoCode"]}
                                                        nameKeys={["name", "countryName"]}
                                                        onSelect={(opt) => {
                                                            handleNewOfficeChange("country", opt.code || opt.name);
                                                            handleNewOfficeChange("countryName", opt.name || opt.code);
                                                            handleNewOfficeChange("state", "");
                                                            handleNewOfficeChange("stateName", "");
                                                            handleNewOfficeChange("city", "");
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        if (key === "state") {
                                            return (
                                                <div key={key}>
                                                    <GeoTypeaheadField
                                                        label={label}
                                                        required={required}
                                                        disabled={!formData.country}
                                                        error={newOfficeErrors.state}
                                                        nameValue={formData.stateName}
                                                        searchFn={(q) => searchStatesByCountry(formData.country, q)}
                                                        codeKeys={["code", "stateCode", "isoCode"]}
                                                        nameKeys={["name", "stateName"]}
                                                        placeholder={formData.country ? undefined : "Select a country first"}
                                                        onSelect={(opt) => {
                                                            handleNewOfficeChange("state", opt.code || opt.name);
                                                            handleNewOfficeChange("stateName", opt.name || opt.code);
                                                            handleNewOfficeChange("city", "");
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        return (
                                            <div key={key}>
                                                <GeoTypeaheadField
                                                    label={label}
                                                    required={required}
                                                    disabled={!formData.country || !formData.state}
                                                    error={newOfficeErrors.city}
                                                    nameValue={formData.city}
                                                    searchFn={(q) => searchCitiesByCountryState(formData.country, formData.state, q)}
                                                    codeKeys={["code", "cityCode"]}
                                                    nameKeys={["name", "cityName"]}
                                                    placeholder={formData.state ? undefined : "Select a state first"}
                                                    onPersistNew={async (typed) => {
                                                        const resp = await saveNewCity(formData.country, formData.state, typed);
                                                        return resp?.data
                                                            ? {code: resp.data.cityName || typed, name: resp.data.cityName || typed}
                                                            : null;
                                                    }}
                                                    onSelect={(opt) => handleNewOfficeChange("city", opt.name || opt.code)}
                                                />
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={key}>
                                            <DisplayDetail
                                                label={label}
                                                required={required}
                                                value={isEditing ? formData[key] : orgData[key]}
                                                isEditable={isEditing}
                                                inputType={inputType}
                                                onChange={(v) => isNew ? handleNewOfficeChange(key, v) : setFormData((prev) => ({...prev, [key]: v}))}
                                            />
                                            <ErrorHint message={newOfficeErrors[key]} />
                                        </div>
                                    );
                                })}
                            </div>

                            {isEditing && !isNew && (
                                <div className="flex justify-end gap-3 p-fluid-3 pt-0">
                                    <button
                                        onClick={() => {
                                            setIsEditing(false);
                                            setFormData(orgData);
                                        }}
                                        className="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-acs-dark-border hover:bg-gray-100 dark:hover:bg-acs-dark-hover disabled:opacity-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSave}
                                        className="px-4 py-2 text-sm rounded-md bg-indigo-600 dark:bg-acs-accent text-white hover:bg-indigo-700 dark:hover:bg-acs-accent/80 disabled:opacity-50"
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* === Location Info === */}
                        {!isNew && orgData.location && (
                        <div className={sectionCardClass}>
                            <div className={`${sectionHeaderBarClass} flex items-center justify-between`}>
                                <span>Location Information</span>
                                {canEditOrganization && !isEditingLocation && (
                                    <button
                                        onClick={handleEditLocation}
                                        className="p-1.5 rounded-full transition hover:bg-white/10"
                                        title="Edit Location"
                                    >
                                        <Pencil className="w-4 h-4 text-white" />
                                    </button>
                                )}
                            </div>
                            {isEditingLocation ? (
                                <>
                                <div className={sectionFieldGridClass}>
                                    {[
                                        {key: "addressLine1", label: "Address Line 1"},
                                        {key: "addressLine2", label: "Address Line 2"},
                                        {key: "city", label: "City"},
                                        {key: "state", label: "State"},
                                        {key: "zipCode", label: "Zip Code"},
                                        {key: "country", label: "Country"},
                                    ].map(({key, label}) => (
                                        <DisplayDetail
                                            key={key}
                                            label={label}
                                            value={locationFormData[key]}
                                            isEditable
                                            onChange={(v) => setLocationFormData({...locationFormData, [key]: v})}
                                        />
                                    ))}
                                </div>
                                <div className="flex justify-end gap-2 p-fluid-3 pt-0">
                                    <button onClick={() => setIsEditingLocation(false)} className="px-4 py-2 text-sm text-gray-600 dark:text-acs-dark-subtext border border-gray-300 dark:border-acs-dark-border rounded hover:bg-gray-100 dark:hover:bg-[#2A2D35]">Cancel</button>
                                    <button onClick={handleSaveLocation} className="px-4 py-2 text-sm text-white bg-indigo-600 rounded hover:bg-indigo-700">Save Changes</button>
                                </div>
                                </>
                            ) : (
                                <div className={sectionFieldGridClass}>
                                    <DisplayDetail label="Address Line 1" value={orgData.location.addressLine1} />
                                    <DisplayDetail label="Address Line 2" value={orgData.location.addressLine2} />
                                    <DisplayDetail label="City" value={orgData.location.city} />
                                    <DisplayDetail label="State" value={orgData.location.state} />
                                    <DisplayDetail label="Zip Code" value={orgData.location.zipCode} />
                                    <DisplayDetail label="Country" value={orgData.location.country} />
                                    <DisplayDetail label="Location Code" value={orgData.location.locationCode} />
                                </div>
                            )}
                        </div>
                        )}

                        {!isNew && orgData.location?.calendar && (
                            <div className={sectionCardClass}>
                                <div className={sectionHeaderBarClass}>Calendar</div>
                                <div className={sectionFieldGridClass}>
                                    <DisplayDetail label="Max Capacity" value={orgData.location.calendar.maxCapacity} />
                                    <DisplayDetail label="Appointment Duration (min)" value={orgData.location.calendar.appointmentDuration} />
                                </div>
                            </div>
                        )}
                           {/* === Auto Approval === */}
                           {!isNew && canViewTolerances && (
                          <div className={sectionCardClass}>
                            <div className={sectionHeaderBarClass}>
                              Invoice Auto Approval
                              {autoApprovalConfig[orgData?.officeCode] && (
                                <span className="block text-xs font-normal text-white/70 mt-0.5">
                                  Invoices with no discrepancies will be automatically approved.
                                </span>
                              )}
                            </div>
                            <div className={sectionContentClass}>
                            {loadingAutoApproval ? (
                              <div className="flex items-center justify-center py-6">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent" />
                              </div>
                            ) : !orgData?.officeCode ? (
                              <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">No office code found.</p>
                            ) : (
                              <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border text-sm">
                                  <thead className="bg-gray-100 dark:bg-[#2A2D35]">
                                    <tr>
                                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Office Code</th>
                                      <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Auto Approval</th>
                                    </tr>
                                  </thead>
                                  <tbody className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
                                  {[orgData.officeCode].map((code) => {
  const isEnabled = autoApprovalConfig[code] ?? false;
  const isSaving = savingAutoApproval === code;
  
  return (
    <tr key={code}>
      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
        <div className="flex items-center gap-2">
          <span>{code}</span>
        
        </div>
      </td>
      <td className="px-3 py-2">
        {canEditTolerances ? (
          <button
            type="button"
            onClick={() => handleToggleAutoApproval(code)}
            disabled={isSaving}
            className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed ${isEnabled ? "bg-indigo-600 dark:bg-acs-accent" : "bg-gray-300 dark:bg-gray-600"}`}
          >
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${isEnabled ? "translate-x-5" : "translate-x-0"}`} />
            {isSaving && (
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="animate-spin h-3 w-3 rounded-full border-b border-white" />
              </span>
            )}
          </button>
        ) : (
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${isEnabled ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" : "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400"}`}>
            {isEnabled ? "Enabled" : "Disabled"}
          </span>
        )}
      </td>
    </tr>
  );
})}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            </div>
                          </div>
                        )}



{/* === Charge Tolerances === */}
{!isNew && canViewTolerances && (
<div className={sectionCardClass}>
  {/* Header row */}
  <div className={`${sectionHeaderBarClass} flex items-center justify-between`}>
    <span>Charge Tolerances</span>

    {canEditTolerances && (
      <div className="flex items-center gap-2">
        {/* Edit toggle */}
        <button
  type="button"
  onClick={() => {
    if (!isEditingTolerances) {
      setOriginalChargeTolerances(chargeTolerances);

      // only enable editing for rows user can see (their shipper codes)
      const visibleIndices = new Set(
        chargeTolerances
          .map((tol, i) => ({ tol, i }))
          .filter(({ tol }) => userShipperOfficeCodes.includes((tol?.shipperCode || "").trim()))

          .map(({ i }) => i)
      );

      setEditingToleranceRows(visibleIndices);
      setIsEditingTolerances(true);
    } else {
      setChargeTolerances(originalChargeTolerances);
      setEditingToleranceRows(new Set());
      setIsEditingTolerances(false);
    }
  }}
  className="p-1.5 rounded-full hover:bg-white/10 transition"
  title={isEditingTolerances ? "Cancel Editing" : "Edit Charge Tolerances"}
>
  <Pencil className="w-4 h-4 text-white" />
</button>

        {/* Add Row */}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleAddToleranceRow();
          }}
          disabled={loadingTolerances}
          className="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md border border-white/30 bg-white/10 text-white hover:bg-white/20 disabled:opacity-60 disabled:cursor-not-allowed"
          title="Add new tolerance row"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add Row
        </button>



      </div>
    )}
  </div>

  {/* Body */}
  <div className={sectionContentClass}>
  {loadingTolerances ? (
    <div className="flex items-center justify-center py-6">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent" />
    </div>
  ) : visibleChargeTolerances.length === 0 ? (
    <p className="text-sm text-gray-500 dark:text-acs-dark-subtext">
      No charge tolerances configured.
    </p>
  ) : (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border text-sm">
        <thead className="bg-gray-100 dark:bg-[#2A2D35]">
          <tr>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Office Code
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Charge Code
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Basis
            </th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
              Tolerance Value
            </th>
        
          </tr>
          
        </thead>
        <tbody className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
        {visibleChargeTolerances.map((tol) => {
  const index = chargeTolerances.findIndex((row) => row === tol);
  const isEditing = editingToleranceRows.has(index);



  return (
    <tr key={tol.id ?? index}>
      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
  {isEditing ? (
    <select
      value={tol.shipperCode ?? ""}
      onChange={(e) => handleToleranceChange(index, "shipperCode", e.target.value)}
      className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
      disabled={loadingShippers}
    >
      <option value="">
        {loadingShippers ? "Loading shippers..." : "Select Office"}
      </option>
      {visibleShippers.map((shipper) => (        <option key={shipper.officeCode} value={shipper.officeCode}>
          {shipper.officeCode} {shipper.name ? `- ${shipper.name}` : ""}
        </option>
      ))}
    </select>
  ) : (
    <span>{tol.shipperCode || "—"}</span>
  )}
</td>

      <td className="px-3 py-2 text-gray-900 dark:text-acs-dark-text">
        {isEditing ? (  // ← Use isEditing instead of isEditingTolerances
        <select
        value={tol.chargeCode ?? ""}
        disabled={!tol.shipperCode?.trim()}
        onChange={(e) => handleToleranceChange(index, "chargeCode", e.target.value)}
      >
            <option value="">Select</option>
            <option value="BASE">BASE</option>
            <option value="FSC">FSC</option>
          </select>
        ) : (
          <span>{tol.chargeCode || "—"}</span>
        )}
      </td>
      <td className="px-3 py-2">
        {isEditing ? (  
         <select
         value={tol.toleranceBasis ?? ""}
         disabled={!tol.chargeCode?.trim()}
         onChange={(e) => handleToleranceChange(index, "toleranceBasis", e.target.value)}
       >
            <option value="">Select</option>
            <option value="FLAT">FLAT</option>
            <option value="PERCENT">PERCENT</option>
          </select>
        ) : (
          <span className="text-gray-900 dark:text-acs-dark-text">{tol.toleranceBasis ?? "—"}</span>
        )}
        
      </td>
      <td className="px-3 py-2">
        {isEditing ? (  
        <input
        type="number"
        value={tol.toleranceValue ?? ""}
        disabled={!tol.toleranceBasis}
        onChange={(e) => handleToleranceChange(index, "toleranceValue", e.target.value)}
      />
        ) : (
          <span className="text-gray-900 dark:text-acs-dark-text">{tol.toleranceValue ?? "—"}</span>
        )}
      </td>
    </tr>
  );
})}

</tbody>
      </table>
      
      {/* Move Save/Cancel buttons HERE - after table closes */}
      {canEditTolerances && editingToleranceRows.size > 0 && (
        <div className="flex justify-end gap-3 pt-3 mt-3 border-t border-gray-200 dark:border-acs-dark-border">
          <button
            type="button"
            onClick={() => {
              setEditingToleranceRows(new Set());
              setChargeTolerances(originalChargeTolerances);
              setIsEditingTolerances(false); 
            }}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-acs-dark-border hover:bg-gray-100 dark:hover:bg-acs-dark-hover text-gray-700 dark:text-acs-dark-text"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveTolerances}
            disabled={
                savingTolerances ||
                loadingTolerances ||
                editingChargeTolerances.some(
                    (t) => !t.shipperCode?.trim() || !t.chargeCode?.trim()
                  )
              }
            className="px-4 py-2 text-sm rounded-md bg-indigo-600 dark:bg-acs-accent text-white hover:bg-indigo-700 dark:hover:bg-acs-accent/80 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {savingTolerances ? "Saving..." : "Save"}
          </button>
        </div>
      )}
    </div>
  )}
  </div>
</div>

)}
                    </div>

                {/* === Office Calendar (LGX-1163) === */}
                {!isNew && (
                <div className={sectionCardClass}>
                    <div className={`${sectionHeaderBarClass} flex items-center justify-between`}>
                        <span>Office Hours</span>
                        {canEditOrganization && officeCalendarSettings && (
                            <button
                                onClick={() => setOpenEditOfficeCalendarModal(true)}
                                className="p-1.5 rounded-full transition hover:bg-white/10"
                                title="Edit Office Hours"
                            >
                                <Pencil className="w-4 h-4 text-white" />
                            </button>
                        )}
                    </div>
                    <div className={sectionContentClass}>
                        {officeCalendarLoading ? (
                            <p className="text-gray-500 dark:text-acs-dark-subtext">Loading office hours...</p>
                        ) : officeCalendarError ? (
                            <p className="text-sm text-red-500">{officeCalendarError}</p>
                        ) : officeCalendarSettings ? (
                            <DockDoorSettings
                                settings={officeCalendarSettings}
                                onChange={() => {}}
                                isViewOnly={true}
                                isWarehouseView={true}
                            />
                        ) : (
                            <div className="flex items-center justify-between">
                                <p className="text-gray-500 dark:text-acs-dark-subtext">
                                    This office has no operating hours set up yet — independent of any warehouse's own calendar.
                                </p>
                                {canEditOrganization && (
                                    <button
                                        type="button"
                                        onClick={handleCreateOfficeCalendar}
                                        disabled={creatingOfficeCalendar}
                                        className="px-4 py-2 text-sm rounded-md bg-indigo-600 dark:bg-acs-accent text-white hover:bg-indigo-700 dark:hover:bg-acs-accent/80 disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap ml-4"
                                    >
                                        {creatingOfficeCalendar ? "Setting up..." : "Set Up Office Hours"}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                )}

                {openEditOfficeCalendarModal && (
                    <EditOfficeCalendarModal
                        officeName={orgData?.name}
                        settings={officeCalendarSettings}
                        onClose={() => setOpenEditOfficeCalendarModal(false)}
                        onSaved={handleOfficeCalendarSaved}
                    />
                )}

          

                {/* === Contact Persons (Full Width Bottom) === */}
                {!isNew && (
                <div className={sectionCardClass}>
                    <div className={sectionHeaderBarClass}>Contact Persons</div>

                    <div className={sectionContentClass}>
                    {loadingContacts ? (
                        <div className="flex items-center justify-center py-8">
                            <div
                                className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent"></div>
                        </div>
                    ) : contactPersons.length > 0 ? (
                        <div className={`
                                    overflow-x-auto
                                    ${contactPersons.length >= 5 ? "max-h-[500px] overflow-y-auto" : ""}
                                `}>
                            <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border">
                                <thead className="bg-gray-100 dark:bg-[#2A2D35]">
                                <tr>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        First Name
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Last Name
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Phone
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Email
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Working Hours
                                    </th>
                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                        Notes
                                    </th>
                                    {(canEditContacts || canRemoveContacts) && (
                                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">
                                            Actions
                                        </th>
                                    )}
                                </tr>
                                </thead>
                                <tbody
                                    className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
                                {contactPersons.filter(Boolean).map((contact, index) => (
                                    <tr key={contact.email || index}>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.firstName || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({...editedContact, firstName: e.target.value})
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.firstName || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.lastName || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({...editedContact, lastName: e.target.value})
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.lastName || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <input
                                                    type="text"
                                                    value={editedContact?.phoneNumber || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({
                                                            ...editedContact,
                                                            phoneNumber: e.target.value
                                                        })
                                                    }
                                                    onBlur={handlePhoneBlur}
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                />
                                            ) : (
                                                contact?.phoneNumber || "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {contact?.email || "—"}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <div className="space-y-2">
                                                    <div className="flex items-center gap-2">
                                                        <input
                                                            type="time"
                                                            value={editedContact?.startWorkingHours || ""}
                                                            onChange={(e) =>
                                                                setEditedContact({
                                                                    ...editedContact,
                                                                    startWorkingHours: e.target.value
                                                                })
                                                            }
                                                            className="border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                        <span>to</span>
                                                        <input
                                                            type="time"
                                                            value={editedContact?.endWorkingHours || ""}
                                                            onChange={(e) =>
                                                                setEditedContact({
                                                                    ...editedContact,
                                                                    endWorkingHours: e.target.value
                                                                })
                                                            }
                                                            className="border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                    </div>
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            value={timezoneSearch || editedContact?.startWorkingHoursZone || ""}
                                                            onChange={(e) => setTimezoneSearch(e.target.value)}
                                                            onBlur={() => {
                                                                if (timezoneSearch && COMMON_TIMEZONES.includes(timezoneSearch)) {
                                                                    setEditedContact({
                                                                        ...editedContact,
                                                                        startWorkingHoursZone: timezoneSearch,
                                                                        endWorkingHoursZone: timezoneSearch
                                                                    });
                                                                }
                                                            }}
                                                            placeholder="Search timezone..."
                                                            className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                        />
                                                        {timezoneSearch && (
                                                            <div
                                                                className="absolute z-10 w-full mt-1 max-h-40 overflow-y-auto bg-white dark:bg-[#2A2D35] border border-gray-300 dark:border-acs-dark-border rounded shadow-lg">
                                                                {COMMON_TIMEZONES.filter(tz =>
                                                                    tz.toLowerCase().includes(timezoneSearch.toLowerCase())
                                                                ).map((tz, i) => (
                                                                    <div
                                                                        key={i}
                                                                        onClick={() => {
                                                                            setEditedContact({
                                                                                ...editedContact,
                                                                                startWorkingHoursZone: tz,
                                                                                endWorkingHoursZone: tz
                                                                            });
                                                                            setTimezoneSearch("");
                                                                        }}
                                                                        className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm"
                                                                    >
                                                                        {tz}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                contact?.startWorkingHours && contact?.endWorkingHours ? (
                                                    <div>
                                                        <div>{formatTo12Hour(contact.startWorkingHours)} - {formatTo12Hour(contact.endWorkingHours)}</div>
                                                        {contact?.startWorkingHoursZone && (
                                                            <div
                                                                className="text-xs text-gray-500 dark:text-acs-dark-subtext">
                                                                {contact.startWorkingHoursZone}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : "—"
                                            )}
                                        </td>
                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                            {editingContactIndex === index ? (
                                                <textarea
                                                    value={editedContact?.contactNotes || ""}
                                                    onChange={(e) =>
                                                        setEditedContact({
                                                            ...editedContact,
                                                            contactNotes: e.target.value
                                                        })
                                                    }
                                                    className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-2 py-1 text-sm bg-white dark:bg-[#2A2D35] text-gray-800 dark:text-acs-dark-text"
                                                    rows="2"
                                                />
                                            ) : (
                                                contact?.contactNotes || "—"
                                            )}
                                        </td>
                                        {(canEditContacts || canRemoveContacts) && (
                                            <td className="px-3 py-3 text-sm">
                                                {editingContactIndex === index ? (
                                                    <div className="flex gap-2">
                                                        {canEditContacts && (
                                                            <>
                                                                <button
                                                                    onClick={handleSaveContact}
                                                                    className="p-1 rounded hover:bg-green-100 dark:hover:bg-green-900/30"
                                                                    title="Save"
                                                                >
                                                                    <Save
                                                                        className="w-4 h-4 text-green-600 dark:text-green-400"/>
                                                                </button>
                                                                <button
                                                                    onClick={handleCancelContactEdit}
                                                                    className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30"
                                                                    title="Cancel"
                                                                >
                                                                    <X className="w-4 h-4 text-red-600 dark:text-red-400"/>
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="flex gap-2">
                                                        {canEditContacts && (
                                                            <button
                                                                onClick={() => handleEditContact(index)}
                                                                className="p-1 rounded hover:bg-gray-100 dark:hover:bg-[#2A2D35]"
                                                                title="Edit"
                                                            >
                                                                <Pencil
                                                                    className="w-4 h-4 text-gray-500 dark:text-acs-dark-subtext"/>
                                                            </button>
                                                        )}
                                                        {canRemoveContacts && (
                                                            <button
                                                                onClick={() => handleRemoveContactPerson(contact)}
                                                                className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30"
                                                                title="Remove"
                                                            >
                                                                <Trash
                                                                    className="w-4 h-4 text-red-600 dark:text-red-400"/>
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-gray-500 dark:text-acs-dark-subtext">
                            No contact persons available.
                        </p>
                    )}
                    </div>
                </div>
                )}

            </div>

            {/* Audit Trail — slide-in panel triggered from the header button, matching
                ShipmentActivity.js / TrailerDetailView.js's Activity drawer pattern, instead of
                the inline collapsible box this used to be (LGX-1006 follow-up). */}
            {showAuditTrail && (
                <div className="fixed inset-0 z-[999]">
                    <div
                        className="absolute inset-0 bg-slate-900/30"
                        onClick={() => setShowAuditTrail(false)}
                    />
                    <aside className="absolute right-0 top-0 h-full w-full max-w-[700px]">
                        <div className="flex h-full flex-col overflow-hidden bg-white shadow-2xl ring-1 ring-black/5 dark:bg-acs-dark-surface dark:ring-acs-dark-border">
                            <header className="flex items-center justify-between gap-2 border-b border-gray-200 bg-gradient-to-r from-acs-primary-navy to-acs-primary-blue px-fluid-3 py-fluid-2 text-white dark:border-acs-dark-border">
                                <div className="flex items-center gap-3">
                                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10">
                                        <Landmark size={20} />
                                    </div>
                                    <div>
                                        <p className="text-xs uppercase tracking-wide text-white/70">
                                            {orgData.name || "Office"}
                                        </p>
                                        <p className="text-fluid-lg font-semibold">Audit Trail</p>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setShowAuditTrail(false)}
                                    className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/60"
                                >
                                    <X size={18} />
                                </button>
                            </header>

                            <div className="flex-1 overflow-y-auto bg-gray-50/60 p-fluid-3 font-roboto text-fluid-base dark:bg-acs-dark-bg">
                                {loadingAuditLogs ? (
                                    <div className="flex items-center justify-center py-8">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-acs-accent"></div>
                                    </div>
                                ) : auditLogs.length === 0 ? (
                                    <div className="flex h-full items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white/70 p-fluid-4 text-fluid-sm text-gray-600 dark:border-acs-dark-border dark:bg-acs-dark-surface dark:text-acs-dark-subtext">
                                        No audit logs found.
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm dark:border-acs-dark-border dark:bg-acs-dark-surface">
                                        <table className="min-w-full divide-y divide-gray-200 dark:divide-acs-dark-border">
                                            <thead className="bg-gray-100 dark:bg-[#2A2D35]">
                                                <tr>
                                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Date</th>
                                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Field</th>
                                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Old Value</th>
                                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">New Value</th>
                                                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-acs-dark-subtext uppercase">Changed By</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white dark:bg-acs-dark-surface divide-y divide-gray-200 dark:divide-acs-dark-border">
                                                {auditLogs.map((log, index) => (
                                                    <tr key={log.id || index}>
                                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">
                                                            {new Date(log.changedAt + "Z").toLocaleString()}
                                                        </td>
                                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">{log.fieldName}</td>
                                                        <td className="px-3 py-3 text-sm text-red-500">{log.oldValue || "—"}</td>
                                                        <td className="px-3 py-3 text-sm text-green-500">{log.newValue || "—"}</td>
                                                        <td className="px-3 py-3 text-sm text-gray-900 dark:text-acs-dark-text">{log.changedBy}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </aside>
                </div>
            )}
        </div>
    );
};
export default ViewPreferredPartnerDetails;